import React, { useState, useEffect } from 'react';
import * as S from './SystemMessageStyle';
import { FiCheckCircle, FiXCircle, FiAlertTriangle, FiInfo, FiX } from 'react-icons/fi';

const icons = {
    success: <FiCheckCircle />,
    error: <FiXCircle />,
    warning: <FiAlertTriangle />,
    info: <FiInfo />,
};

const SystemMessage = ({ message, type = 'info', onClose }) => {
    const [isFadingOut, setIsFadingOut] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            handleClose();
        }, 2500); // Inicia o fade-out 500ms antes de fechar

        return () => clearTimeout(timer);
    }, []);

    const handleClose = () => {
        setIsFadingOut(true);
        setTimeout(onClose, 500); // Espera a animação de fade-out terminar
    };

    const icon = icons[type] || icons.info;

    return (
        <S.MessageWrapper type={type} className={isFadingOut ? 'fade-out' : ''}>
            <S.IconWrapper>{icon}</S.IconWrapper>
            <S.MessageText>{message}</S.MessageText>
            <S.CloseButton onClick={handleClose}>
                <FiX />
            </S.CloseButton>
        </S.MessageWrapper>
    );
};

export default SystemMessage;